// src/components/WhatsAppButton.js
import React from 'react';
import './WhatsAppButton.css';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  // Número de telefone extraído dos dados cadastrais [cite: 6, 23]
  const phoneNumber = "5511977211739";
  const message = "Olá! Gostaria de mais informações sobre as soluções Intelbras ou sobre instalações. Deixo abaixo meu contato e solicitação. Solicito retorno do contato em breve.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppButton;